<template>
  <div>
    <div class="wrap survey-report-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>Embedded Survey 리포트</h3>
      </div>
      <div class="body-wrap">
        <div class="time">
          <img src="@/assets/img/time-icon-b.svg" alt="시간 아이콘" />
          <p>{{ course.startDate }}({{ course.day }}) {{ course.startTime }}~{{ course.endTime }} ({{ course.time }}분)</p>
        </div>
        <div class="coach">
          <div class="w-100per clear">
            <div class="w-50per float-left txt-left">
              <p class="company">{{ course.companyName }}</p>
            </div>
          </div>
          <div class="info">
            <h3>
              {{ course.userName }} <span>{{ course.userGrade }}</span>
            </h3>
            <h4>{{ course.sessionType }}코칭 <span></span>{{ course.currentSession }}회기</h4>
          </div>
          <div class="contact">
            <ul>
              <li>
                <img src="@/assets/img/phone-call.svg" @click="sendCall()" v-if="isCall" class="call-img" />
                <img src="@/assets/img/mic.svg" @click="sendWebex()" v-if="isWebex" class="mic-img" />
                <img src="@/assets/img/talk-message.svg" alt="대화아이콘" @click="viewMessage()" />
              </li>
            </ul>
          </div>
        </div>
        <div class="report">
          <table>
            <tr>
              <th>대분류</th>
              <th>소분류</th>
            </tr>
            <tr v-for="(item, index) in report" :key="index">
              <td class="title">{{ item.surveyOrder }}.{{ item.categorySubject }}</td>
              <td>
                <ul>
                  <li class="clear" v-for="(subItem, subIndex) in item.embeddedSurveyChild" :key="subIndex">
                    <span v-if="subItem.surveyOrder >= 1">
                      {{ subItem.surveyOrder }}
                    </span>
                    <span v-else class="disable">-</span>
                    <p>{{ subItem.categorySubject }}</p>
                  </li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import dayjs from "dayjs";
export default {
  name: "embedded_survey_report",
  props: {
    userIdx: {
      type: [Number, String],
      default: 0,
    },
    sessionIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    report: [],
    course: {},
    isWebex: false,
    isCall: false,
  }),
  components: {
    incBack,
  },
  mounted() {
    this.getEmbededSurvey();
    this.getCoarchingDetail();
  },
  methods: {
    sendCall() {
      if (confirm("고객에게 전화를 걸겠습니까?")) {
        location.href = "tel:" + this.course.userHandphone;
      }
    },
    sendWebex() {
      if (confirm("고객에게 화상미팅 URL을 전달 하시겠습니까? ")) {
        let params = {
          userIdx: 0,
          coachIdx: 0,
          origin: "COACH",
          chatContent: "",
        };
        params.userIdx = this.course.userIdx;
        params.coachIdx = this.$store.state.userInfo.idxTbCoarch;
        params.chatContent = `안녕하세요 ${this.course.userName} 고객님<br>화상 미팅 URL 전달드립니다.<br>URL : <a href="${this.course.coarchingWebxUrl}" target="_blank">${this.course.coarchingWebxUrl}</a>`;
        this.axios
          .post("/chat/send", params)
          .then((res) => {
            if (res.data.success) {
              alert("화상 미팅 URL을 전달하였습니다.");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    viewMessage() {
      this.$router.push({ name: "message", params: { userIdx: this.course.userIdx } });
    },
    getCoarchingDetail() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/reservation/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.course = res.data.contentinfo.coarchReservationList;
            if (this.course.sessionType.includes("화상")) {
              this.isWebex = true;
            } else {
              this.isWebex = false;
            }
            if (this.course.sessionType.includes("전화")) {
              this.isCall = true;
            } else {
              this.isCall = false;
            }

            this.course.startDate = dayjs(this.course.startDate).format("YYYY-MM-DD HH:mm:ss").replace(/-/g, "/");
            this.$store.commit("setCoachingDays", dayjs(this.course.startDate).day());
            this.course.day = this.$store.state.coachingDays;

            this.course.startTime = dayjs(this.course.startDate).format("HH:mm");
            this.course.endTime = dayjs(this.course.endDate).format("HH:mm");

            let timeValue = {
              startTime: this.course.startTime,
              endTime: this.course.endTime,
            };
            this.$store.commit("setCoachingTime", timeValue);
            this.course.time = this.$store.state.coachingTime;

            this.course.startDate = dayjs(this.course.startDate).format("YYYY.MM.DD");

            let temp = this.course.sessionPer.split("/");
            this.course.currentSession = temp[0];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getEmbededSurvey() {
      let params = {
        userIdx: this.userIdx,
      };
      this.axios
        .get("/admin/userCoarching/embeddedsurvey/list", { params })
        .then((res) => {
          if (res.data.success) {
            this.report = res.data.contentinfo.embeddedSurveyParent;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
